import React from "react"
import "./style.scss"
import LearnMore from "../../elements/learnmore/LearnMore"
import { GatsbyImage } from "gatsby-plugin-image"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';

// import Accordion from "react-bootstrap/Accordion"

// import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
// import ShowMoreIcon from "../../../images/Icon-showmore.svg"

// const Toggle = ({ children, eventKey }) => {
//   const decoratedOnClick = useAccordionToggle(eventKey, () => {
//     if (document.getElementById("showMore").style.display === "none") {
//       document.getElementById("showMore").style.display = "block"
//     } else {
//       document.getElementById("showMore").style.display = "none"
//     }
//   })

//   return (
//     <div className="angle" onClick={decoratedOnClick}>
//       {children}
//     </div>
//   )
// }

const useStyles = makeStyles(theme => ({
  moreBtn: {
    textAlign: 'start',
  },
  readmoreBtn: {
    borderRadius: '22.4225px',
    borderWidth: 'medium',
    borderColor: '#66B185',
    textTransform: 'none',
  },
  bookdemoBtn: {
    borderRadius: '22.4225px',
    background: 'conic-gradient(from 180deg at 50% 50%, #6FC0CE -103.12deg, #66B185 70.56deg, #67B48D 136.88deg, #6FC0CE 256.87deg, #66B185 430.56deg)',
    textTransform: 'none',
  },
}))

const Description = ({ title, descriptionText, descriptionText2, descriptionText3, learn_more_url }) => {
  const classes = useStyles()
  const theme = useTheme()
  return (
    <div className="solution-description">
      <div>
        <h3 className="solution-title" style={{ textAlign: "left" }}>
          {title}
        </h3>
        <p style={{ textAlign: "left" }}>{descriptionText}</p>
        <p style={{ textAlign: "left" }}>{descriptionText2}</p>
        <p style={{ textAlign: "left" }}>{descriptionText3}</p>
      </div>
      {/* <div className={classes.moreBtn}>
      <Button className={classes.readmoreBtn} variant="outlined" endIcon={<TrendingFlatIcon />}> Read More </Button>&nbsp;&nbsp;&nbsp;
      <Button className={classes.bookdemoBtn} variant="contained"> Book Demo </Button>
      </div> */}
    </div>
  )
}
const SolutionFeature = ({
  featureTitle,
  featureDescription,
  featureDescription2,
  featureDescription3,
  productImage,
  imageDirection,
  hack,
  url,
  stylePadding,
}) => {
  if (imageDirection !== "right") {
    return (
      <>
      <div className="highScreen">
        <div
          className={`solution-item ${imageDirection ? imageDirection : ""} ${
            hack ? hack : ""
          }`}
          style={{ justifyContent: "center", display: "flex" }}
        >
            <div className="img-container">
              <img src={productImage} alt={featureTitle} />
            </div>
            <Description
              title={featureTitle}
              descriptionText={featureDescription}
              descriptionText2={featureDescription2}
              descriptionText3={featureDescription3}
              learn_more_url={url}
            />
        </div>
      </div>
      <div className="lowScreen">
        <div
          className={`solution-item ${imageDirection ? imageDirection : ""} ${
            hack ? hack : ""
          }`}
          style={{ justifyContent: "center", display: "flex" }}
        >
            <Description
              title={featureTitle}
              descriptionText={featureDescription}
              descriptionText2={featureDescription2}
              descriptionText3={featureDescription3}
              learn_more_url={url}
            />
            <div className="img-container">
              <img src={productImage} alt={featureTitle} />
            </div>

        </div>
      </div>
      </>
    )
  }
  return (
    <>
    <div className="highScreen">
      <div
        className={`solution-item ${imageDirection ? imageDirection : ""} ${
          hack ? hack : ""
        }`}
        style={{ textAlign: "center" }}
      > 
          <Description
            title={featureTitle}
            descriptionText={featureDescription}
            descriptionText2={featureDescription2}
            descriptionText3={featureDescription3}
            learn_more_url={url}
          />
          <div className="img-container" style={{ paddingLeft: stylePadding ? stylePadding : 'none' }}>
            <img src={productImage} alt={featureTitle} />
          </div>

      </div>
    </div>
    <div className="lowScreen">
      <div
        className={`solution-item ${imageDirection ? imageDirection : ""} ${
          hack ? hack : ""
        }`}
        style={{ textAlign: "center" }}
      > 
          <div className="img-container" style={{ paddingLeft: stylePadding ? stylePadding : 'none' }}>
            <img src={productImage} alt={featureTitle} />
          </div>
          <Description
            title={featureTitle}
            descriptionText={featureDescription}
            descriptionText2={featureDescription2}
            descriptionText3={featureDescription3}
            learn_more_url={url}
          />

      </div>
    </div>
    </>
  )
}
const CustomProducts = ({ withTitle, features, homePage }) => {
  //console.log(features, "features")
  // let featureListOne, featureListTwo
  // if (homePage && features) {
  //   featureListOne = features.slice(0, 2)
  //   featureListTwo = features.slice(2)
  // }
  return (
    <div className={`products ${withTitle ? "withTitle" : ""}`}>
      {withTitle && <h3 className="title">{withTitle}</h3>}
      <div className="solutions-area">
        {features &&
          homePage &&
          features.map((feature, index) => {
            return (
              <SolutionFeature
                key={index}
                featureTitle={feature.featureTitle}
                featureDescription={feature.featureDescription}
                featureDescription2={feature.featureDescription2}
                featureDescription3={feature.featureDescription3}
                productImage={feature.featureImage}
                imageDirection={feature.imagePosition}
                hack={feature.hack}
                url={feature.url}
                stylePadding={feature.stylePadding}
              />
            )
          })}

        {/* {homePage && (
          <React.Fragment>
            {featureListOne.map((feature, index) => {
              return (
                <SolutionFeature
                  key={index}
                  featureTitle={feature.featureTitle}
                  featureDescription={feature.featureDescription}
                  productImage={feature.featureImage}
                  imageDirection={feature.imagePosition}
                  url={feature.url}
                />
              )
            })}
            <Accordion className="show-more-accordion">
              <Accordion.Collapse eventKey="0">
                <div>
                  {featureListTwo.map((feature, index) => {
                    return (
                      <SolutionFeature
                        key={index}
                        featureTitle={feature.featureTitle}
                        featureDescription={feature.featureDescription}
                        productImage={feature.featureImage}
                        imageDirection={feature.imagePosition}
                        hack={feature.hack}
                        url={feature.url}
                      />
                    )
                  })}
                </div>
              </Accordion.Collapse>
              <Toggle eventKey="0">
                <p className="show-more">
                  <span id="showMore">Show More</span>
                  <span>
                    <img src={ShowMoreIcon} alt="show more" />
                  </span>
                </p>
              </Toggle>
            </Accordion>
          </React.Fragment>
        )} */}
      </div>
    </div>
  )
}
export default CustomProducts
